export default __webpack_public_path__ + "static/simple-bubble-9fd7c6e4c5de60f30919325bf89e693f.png";